module.exports = __webpack_public_path__ + "GH.png?13ac7cc14c487aa7bf4a1d97c0b5ce2a";